import * as React from 'react';
import i18next from 'i18next';
import { getEtapas } from '~services/EtapaService';
import { useCachedResource } from 'app/hooks/useCachedResource';
import styles from './styles.module.scss';
import './i18n';

interface Stage {
  id: number;
  order: number;
  name: string;
}

interface Props {
  /** The Acción's Etapa order (1 = the first stage). */
  order: number;
  /** `sm` on cards and popups, `md` on the action sheet. */
  size?: 'sm' | 'md';
  className?: string;
}

// The Etapas, loaded once per session for every card.
const stagesCache = new Map<string, Stage[]>();

/** The stages as dots on a line: done in green, the current one as a ring, the rest gray. */
const StageProgress = ({ order, size = 'sm', className }: Props) => {
  const stages = useCachedResource(stagesCache, 'etapas', () => getEtapas() as Promise<{ ok: boolean; data?: Stage[] }>, []);
  if (!stages || !stages.length) {
    return null;
  }
  const sorted = [...stages].sort((a, b) => a.order - b.order);
  const current = sorted.find(stage => stage.order === order);
  const label = i18next.t('stage-progress:label', {
    stage: current ? current.name : '-', position: sorted.indexOf(current as Stage) + 1, total: sorted.length
  }) as string;

  return (
    <ol className={`${styles.progress} ${styles[size]} ${className || ''}`} aria-label={label}>
      {sorted.map(stage => {
        const state = stage.order < order ? styles.done : stage.order === order ? styles.current : styles.future;
        return (
          <li key={stage.id} className={`${styles.dot} ${state}`}>
            <span className={styles.tooltip} aria-hidden="true">{stage.name}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default StageProgress;
